<template>
  <div>
    <h1>BRIGHTON YOUR WAY</h1>
    <span class="line">
    </span>
    <span class="title">Brighton's Love Lockets &amp; More</span>
    <img class="mainBanner" src="https://app.brighton.com/lockets/img/locket_main_banner2.jpg" alt="Brighton your way - Love Lockets &amp; more">
    <span class="subtitle">Carry your fondest memories with you! Brighton’s Love Lockets and several accessories can be personalized with the photo of your choice inside. After you’ve selected your favorite Brighton Treasure, upload a photo, and resize it using our easy online tool. 
<br/><br/>
When you place your order, we will be happy to print your uploaded photo and insert it in your Brighton treasure for you, or you may take it to a Brighton Retailer and they will print and place it inside for you. Or, if you’d prefer, simply print it at home!  </span>
  <span style="padding-bottom:30px;display:block;font-size:20px"><strong>Make Your Selection</strong></span>
    <!--UPLOAD-->
     <div class="lockets">
      <div v-for="(locket) in lockets" class='locket'>
          <div v-if="locket.styleNum == 'xyz'" class="text">
            <div>
              <span class="t1">LOCKET PHOTO TEMPLATE</span>
              <span class="t2">tell your story</span>
              <span class="t3">When you upload your photo using our online resizing tool, you may custom create a perfectly sized photo just for your locket. Select your favorite locket to get started.</span>
            </div>
          </div>
          <!-- <div v-if="locket.styleNum == 'wallet' && parseInt($route.params.storeType) == 2" class="text">
            <img src="https://app.brighton.com/pictured-accessories/img/wallets_01.jpg" style="" :alt="locket.styleNum.toLowerCase()">
            <span class="t1">Wallets</span>
          </div> -->
          <div v-if="locket.styleNum != 'xyz'" @click="$emit('selectStyleNum', locket)">
            <div class="sizingSymbol">  
              <img v-if="locket.sides == 1" class="" :src="'https://app.brighton.com/lockets/img/one-side.png?0'" alt="One sided">
              <img v-if="locket.sides == 2" class="" :src="'https://app.brighton.com/lockets/img/two-sides.png?0'" alt="Two sided">
              <span>Holds {{locket.sides}} Photo<span v-if="locket.sides == 2">s</span></span>
            </div>
            <!-- <img :src="'https://app.brighton.com/lockets/img/'+locket.styleNum+'_01.jpg?34'" style="" :alt="locket.styleNum.toLowerCase()"> -->
            <img :src="'https://media.brighton.com/images/900x900/qi'+locket.styleNum.toLowerCase()+'_01.jpg'" style="" :alt="locket.styleNum.toLowerCase()">
            <span class="t1">{{locket.name}}
              <span class="size" v-if="locket.productWidth != ''">
                Product Size {{locket.productWidth}}
              </span>
            </span>
          </div>
      </div>
      <div class="locket" v-if="parseInt($route.params.storeType) != 1">
        <a :href="'/pictured-accessories/create/'+parseInt($route.params.storeType)" class="" style="text-decoration: none">
          <img src="https://app.brighton.com/pictured-accessories/img/wallets_01.jpg" style="max-width:500px; " alt="Wallets">
          <span class="t1">Wallets</span>
        </a>
      </div>
     </div>
  </div>
</template>

<script>
export default {
  name: 'Step0',
  props: {
    reloadObj: Array,
    selectedStyleNum: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      isSaving: false,
      uploadFieldName: 'abc',
      isInitial: true,
      lockets: [],
      reloadObjLocal: null
    }
  },
  methods: {
    getLockets(callBack) {
      console.log(process.env)
      this.$http.post(
        'https://app.brighton.com/lockets/api/getAllStyles',
        {
          NODE_ENV: process.env.NODE_ENV,
          storeType: parseInt(this.$route.params.storeType)
        },
        {emulateJSON: true}
      ).then(response => {
        // success callback
        if(response.body.success) {
          
          this.lockets = response.body.data;
        }
        callBack();
      }, response => {
        // error callback
        callBack();
      });
    }
  },
  watch: {
    reloadObj(newValue, oldValue) {
      var that = this
      if(this.reloadObj != null) {
        _.forEach(that.lockets, function (locket){
          if (locket.styleNum == that.reloadObj[0].styleNum) {
            that.$emit('selectStyleNum', locket)
          }
        });
      }
    }
  },
  mounted: function() {
    var that = this
    this.getLockets(function () {
      if(that.selectedStyleNum != '') {
        that.lockets.forEach(function(locket, index){
          if(locket.torreyProductID == that.selectedStyleNum || locket.styleNum.toLowerCase().trim() == that.selectedStyleNum.toLowerCase().trim())
             that.$emit('selectStyleNum', locket)
        })
      }      
      
    });
    console.log('mounted step 0')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1{
  margin-top:0;
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.img div{
  cursor: pointer;
  max-width:100px;
  border:1px solid #fff;
  /*background-color*/
  box-sizing: border-box;
  padding:4px;
}
.img div:hover{
  border:1px solid #000;
}
.img div img{
  display:block;
  max-width:100%;
  width:auto;
}

.home{
  display:block;
}
.home h1{
  /*font-size:35px;*/
  font-size: 30px;
  font-weight: 300;
  text-transform: uppercase;
  padding:20px 0 10px 0;
}
.home .line{
  display:block;
  width:180px;
  height:3px;
  background-color:#ebebeb;
  margin:0 auto;
  text-align: left;
  position:relative;
}
.home .line:after{
  content:' ';
  width:60%;
  background-color:#cc0033;
  height:3px;
  display:block;
}
.home .title{
  font-weight:bold;
  margin:15px 0;
  font-size:30px;

  font-size: 40px;
font-weight: bold;
line-height: 1em;
letter-spacing: -.06em;
}
.home img.mainBanner{
  max-width:100%;
  width:auto;
  margin: 0 auto;
  display:block;
}
.home .subtitle{
  display:block;
  margin:50px auto;
  width:auto;
  max-width:1170px;
  letter-spacing: 1.2;
  text-align: center;
  box-sizing: border-box;
  font-family: Lato;
  line-height:1.6em;
  font-size:1.2em;
  letter-spacing: .06em;
  color:#000000;

}
.home .lockets{
  display:block;
  max-width:1170px;
  margin:0 auto;
  text-align: left;
  display:flex;
  /*flex-direction: row;*/
  flex-wrap: wrap;
  justify-content: flex-start;
  
}
.home .lockets div.locket{
  display:inline-block;
  box-sizing: border-box;
  /* width:calc(50% - 20px);*/
  width:calc(50% - 5px);
  text-align: center;
  vertical-align: top;
  padding:20px;
  border:1px solid #ccc;
  vertical-align: middle;
  cursor: pointer;
  margin:5px;
  position:relative;
}
.home .lockets div.locket img{
  display:block;
  max-width:100%;
  margin:50px auto;
}
.home .lockets div.locket .sizingSymbol{
  position:absolute;
  position: absolute;
    bottom: 10px;
    right: 10px;
    margin: 0;
    width: auto;
}
.home .lockets div.locket .sizingSymbol img{
    margin: 0;
    width: 66px;
    display: block;
    margin-right: 0;
    margin-left: auto;
}
.home .lockets div.locket .sizingSymbol span{
    font-size: 11px;
    white-space: nowrap;
    display: inline-block;
    margin: 0 auto;
    padding: 0;
    line-height: 11px;
    vertical-align: top;
    font-weight:bold;
}
.home .lockets div.locket .text div{
  display:inline-block;
  vertical-align: middle;
}
.home .lockets div.locket .text:after{
  content: ' ';
  display:inline-block;
  width:1px;
  height:100%;
  vertical-align: middle;
}
.home .lockets div.locket .text .t1{
    font-size: 17px;
    display:block;
    font-weight: bold;
    text-align: center;
    padding: 10px 0;
    letter-spacing: 2px;
    text-decoration: none;
    margin:0;
    margin-top:30%;
}
.home .lockets div.locket .text .t2{
  display:block;
  font: normal normal 51px/1.4 'Freeland', Arial, Helvetica, sans-serif;
}
.home .lockets div.locket .text .t3{
    display: block;
    font-size: 16px;
    font-weight: bold;
    color: #666;
    line-height:1.6;
    text-align: center;
    padding: 0 0 24px 0;
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
    letter-spacing: 2px;
}
.home .lockets div.locket:nth-child(even){
  margin-right:0;
}
.home .lockets div.locket:nth-child(odd){
  margin-left:0;
}
.home .lockets div.locket .t1{
display: block;
    font-size: 20px;
    font-weight: bold;
    color: #666;
    text-align: center;
    padding: 0 0 50px 0;
    max-width: 100%;
    margin: 0 auto;
    width: 100%;
}
.home .lockets div.locket .t1 span{
  font-size:14px;
  line-height:1.3;
  display:block;
}
@media(max-width:1010px) {
  .home .lockets div.locket .t1{
    padding-bottom:50px;
  }
}
@media(max-width:768px) {
  .home .subtitle{
    width:100%;
    box-sizing:border-box;
    padding:0 15px;
    line-height:1.5;
    font-size:18px;
  }
  .home .lockets div.locket .text .t2{
    line-height:1.2;
    font-size:45px;
    padding:15px 0;

  }
  .home .lockets div.locket[data-v-6418b704]:nth-child(odd){
    padding:5px;
  }
}
@media(max-width:415px) {
  .home .lockets div.locket{
    margin: 5px;
    width: 90%;
    /* margin: 0 5px; */
    margin-right: 0;
    margin-left: 0;
  }
}
</style>

<style type="text/css">
@import url("https://hello.myfonts.net/count/302a5c");
/*
@font-face {
  font-family: 'Freeland';
  src: url("http://www.brighton.com/content/302A5C_0_0.eot");
  src: url("http://www.brighton.com/content/302A5C_0_0.eot?#iefix") format("embedded-opentype"), url("http://www.brighton.com/content/302A5C_0_0.woff2") format("woff2"), url("http://www.brighton.com/content/302A5C_0_0.woff") format("woff"), url("http://www.brighton.com/content/302A5C_0_0.ttf") format("truetype");
}*/
@font-face {
  font-family: 'Freeland';
  src: url("https://app.brighton.com/personalization/includes/fonts/302A5C_0_0.eot");
  src: url("https://app.brighton.com/personalization/includes/fonts/302A5C_0_0.eot?#iefix") format("embedded-opentype"), url("https://app.brighton.com/personalization/includes/fonts/302A5C_0_0.woff2") format("woff2"), url("https://app.brighton.com/personalization/includes/fonts/302A5C_0_0.woff") format("woff"), url("https://app.brighton.com/personalization/includes/fonts/302A5C_0_0.ttf") format("truetype");
}
  </style>